module.exports = __webpack_public_path__ + "images/emoji/minibus.10397d58cc5dada85fd6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/minibus.png
// module id = nlGu
// module chunks = 13